<template>
  <div class="mainGlobeOperation">

<!--    &lt;!&ndash;搜索框&ndash;&gt;-->
<!--    <div style="position:relative;z-index:15;">-->
<!--      <v-text-field v-model="search_keyword" @focus="searchInputFocus" @blur="searchInputBlur" @keyup.enter.native="searchInputEnter"-->
<!--                    id="keywordInputArea_globeOperation" autocomplete="off" dense outlined placeholder="地点，经纬度（例如125.3 43.8）" dark hide-details color="#ffffff" style="width:308px;background:#2a2a2a;">-->
<!--        <template v-slot:append>-->
<!--          <p style="font-size:16px;font-weight:bold;color:#ffffff;cursor:pointer;" class="iconfontFamily mt-1">&#xe630;</p>-->
<!--        </template>-->
<!--      </v-text-field>-->
<!--      <div @click="clearSearchKeyword" v-if="search_keyword!==''" style="position:absolute;top:12px;right:40px;width:16px;height:16px;cursor:pointer;">-->
<!--        <p style="line-height:16px;font-size:16px;color:#c4c4c4;" class="iconfontFamily">&#xe632;</p>-->
<!--      </div>-->

<!--      <div v-show="search_resultAreaShow" style="position:absolute;top:42px;width:308px;background:#2a2a2a;border-radius:2px;padding:0 16px;box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);">-->

<!--        &lt;!&ndash;历史记录&ndash;&gt;-->
<!--        <div v-show="search_resultAreaHistoryShow && search_history.length !== 0" style="margin:7px 0;">-->
<!--          <div @click="clickSearchHistory(item)" v-for="(item,index) in search_history" :key="'searchHistory'+index" style="min-height:35px;font-size:14px;color:#ffffff;cursor:pointer;display:flex;">-->
<!--            <p style="line-height:35px;" class="iconfontFamily mr-4">&#xe63f;</p>-->
<!--            <p style="line-height:35px;">-->
<!--              {{item.type === 2 ? item.lon + " " + item.lat : item.keyWord}}-->
<!--            </p>-->
<!--          </div>-->

<!--          <div @click="clearSearchHistory" style="text-align:center;color:#A6A6A6;font-size:14px;cursor:pointer;">-->
<!--            <p style="line-height:31px;">清空历史记录</p>-->
<!--          </div>-->

<!--        </div>-->

<!--        &lt;!&ndash;联想结果&ndash;&gt;-->
<!--        <div v-show="search_resultAreaAssociativeShow && search_result.length !== 0" style="margin:7px 0;">-->
<!--          <div @click="clickSearchResult(item)" v-for="(item,index) in search_result" :key="'searchAssociative'+index" style="min-height:35px;font-size:14px;color:#ffffff;cursor:pointer;display:flex;">-->
<!--            <span style="line-height:35px;" class="iconfontFamily mr-4">{{item.name === "经纬度地点" ? "&#xe63a;" : "&#xe628;"}}</span>-->
<!--            <p style="line-height:35px;">-->
<!--              {{item.name === "经纬度地点" ? item.location.lng + " " + item.location.lat :item.name}}-->
<!--            </p>-->
<!--          </div>-->
<!--        </div>-->



<!--      </div>-->
<!--    </div>-->



    <div style="width:310px;height:100%;color:#ffffff;display:flex;flex-direction:column;">
      <!--文件-->
      <div class="folderArea">
        <div style="display:flex;margin:16px 15px 0 20px;">
          <v-menu offset-y nudge-bottom="12" nudge-left="9" min-width="186">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" style="width:20px;height:16px;margin-right:15px;cursor:pointer;">
                <p style="font-size:18px;" class="iconfontFamily">&#xe662;</p>
              </div>
            </template>
            <div class="folderArea-moreOperation py-4">
              <div @click="createFolder()" class="folderArea-moreOperationItem">
                <p>新建文件</p>
              </div>
              <div @click="chooseFolder()" class="folderArea-moreOperationItem">
                <p>打开/导入文件</p>
              </div>
              <div style="color:#A6A6A6" class="folderArea-moreOperationItem">
                <p>图层导入</p>
              </div>
              <div @click="saveFolder" class="folderArea-moreOperationItem">
                <p>保存</p>
              </div>
              <div @click="reSaveFolder()" class="folderArea-moreOperationItem">
                <p>另存为</p>
              </div>
              <div @click="exportFolder()" class="folderArea-moreOperationItem">
                <p>数据导出</p>
              </div>
              <div style="color:#A6A6A6" class="folderArea-moreOperationItem">
                <p>文件分享</p>
              </div>
              <div style="color:#A6A6A6" class="folderArea-moreOperationItem">
                <p>查看历史</p>
              </div>
              <div style="width:157px;height:1px;background:#545454;margin:0 auto;"></div>
              <div class="folderArea-moreOperationItem" style="margin-top:14px;margin-bottom:0;">
                <p @click="openGlobeSet">地图设置</p>
              </div>
            </div>


          </v-menu>


          <!--文件名及编辑-->
          <p @dblclick="intoEditFolderName($event)" v-show="!editFolderNameShow" style="height:85px;line-height:28px;font-size:18px;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;overflow: hidden;word-break: break-all">{{$store.state.currFolderName}}</p>
          <div v-show="editFolderNameShow" style="height:85px">
            <v-textarea @blur="editFolderNameOk" v-model="$store.state.currFolderName" dark hide-details no-resize rows="1" auto-grow class="editFolderNameTextField" maxLength="30"></v-textarea>
            <div style="width: 232px;height: 1px;background: rgba(166, 166, 166, 1)"></div>
          </div>
        </div>
        <div style="display:flex;height: 50px;margin-top: 10px">
          <!--个人的显示-->
          <p v-if="$store.state.currFolderType === 0" style="margin-left:33px;font-size:16px;color:#A6A6A6;">个人-{{$store.state.currFolderPublicStatus === 1 ? "公开" : "未公开"}}</p>
          <!--团队的显示-->
          <div v-else style="height: 50px;background: transparent;width: 100%;cursor: pointer" @click="openMemberList">
            <v-layout row justify-space-between align-center  fill-height class="ma-0">
              <div style="display: flex;margin-left: 22px;height: 22px;align-items: center;" >
                <span style="font-size: 16px;color: rgba(166, 166, 166, 1)" class="iconfontFamily">&#xe605;</span>
                <div style="font-size: 16px;color: rgba(166, 166, 166, 1);line-height: 22px;margin-left: 7px">团队文件</div>
                <div style="font-size: 12px;color: rgba(166, 166, 166, 1);line-height: 22px;margin-left: 5px">(共{{$store.state.currFolderMembersNumber}}人)</div>
              </div>
              <div style="display: flex;margin-right: 15px">
                <template v-for="(item,index) in $store.state.currFolderMember">
                  <v-avatar color="#A6A6A6" size="20" style="margin-left: -8px;" :style="{zIndex:100-index}" :key="index">
                    <v-img :src="item" style="width:100%;height:100%;"></v-img>
                  </v-avatar>
                </template>
                <div style="font-size: 14px;line-height: 20px;margin-left: 10px">
                  查看
                </div>
              </div>
            </v-layout>

          </div>
<!--          <v-spacer></v-spacer>-->
<!--          <p style="margin-right:16px;font-size:16px;color:#63A8F7;cursor:pointer;">管理</p>-->
<!--          <p style="font-size:16px;color:#63A8F7;cursor:pointer;">同步</p>-->
        </div>
      </div>
<!--      <v-btn @click="saveFolder" width="280" height="50" dark depressed color="#1976D2" style="margin:16px auto;border-radius:11px;display:block;">-->
<!--        <p style="font-size:18px;"><span style="margin-right:7px;" class="iconfontFamily">&#xe66f;</span>保存</p>-->
<!--      </v-btn>-->
<!--      <div style="width:100%;height:1px;background:#545454;"></div>-->

      <!--数据列表折叠-->
      <div v-if="!dataListShow" style="height:48px;width: 100%;border-radius:10px;background:rgba(42, 42, 42, 1);margin-top: 11px">
        <v-layout row class="ma-0" justify-space-between align-center fill-height>
          <div style="font-size: 16px;font-weight: bold;line-height: 22px;margin-left: 20px">数据列表</div>
          <div style="display: flex;margin-right: 10px;">
            <v-layout class="ma-0" align-center fill-height>

<!--              <v-badge v-if="true" color="#ff0000" dot offset-x="11" offset-y="6">-->
<!--                <div @click="" style="font-size:20px;color:#ffffff;cursor:pointer;" class="iconfontFamily">&#xe608;</div>-->
<!--              </v-badge>-->
              <div v-if="$store.state.currFolderType ===1" style="font-size:20px;color:#ffffff;cursor:pointer;" class="iconfontFamily">&#xe608;</div>
            <!--  <v-tooltip bottom color="rgba(100, 100, 102, 1)">
                <template v-slot:activator="{ on, attrs }">
                   <div style="font-size:20px;cursor:pointer;margin-left: 15px" class="iconfontFamily" v-bind="attrs" v-on="on">&#xe64f;</div>
                </template>
                <span style="color: white">新建文件夹</span>
              </v-tooltip>-->

              <div style="font-size:20px;cursor:pointer;margin-left: 15px" class="iconfontFamily">&#xe64f;</div>
              <div style="color: white;font-size: 20px;margin-left: 8px;cursor: pointer" class="iconfontFamily" @click="dataPanelOperation('open')">&#xe6a7;</div>
            </v-layout>

          </div>
        </v-layout>
      </div>
      <!--数据列表展开-->
<!--      :style="{'height':$store.state.exampleList.length === 0 ? 'calc(100% - 250px)' :$store.state.exampleShow ?$store.state.exampleList.length > 2 ? 'calc(100% - 493px)' : 'calc(100% - 415px)': 'calc(100% - 295px)'}"-->
      <div v-else style="position:relative;margin-top: 11px;height: calc(100% - 258px);width: 100%;border-radius: 10px;background: rgba(42, 42, 42, 1)">
        <div style="position:fixed;width:310px;height:54px;padding:17px 0;background:#2a2a2a;display:flex;align-items:center;border-top-right-radius: 10px;border-top-left-radius:10px">
          <v-layout class="ma-0" fill-height justify-space-between align-center>
            <div style="display: flex">
              <div style="width:5px;height:20px;background:#20518A;border-radius:5px;"></div>
              <p style="margin-left:15px;font-size:16px;line-height:20px;">数据列表</p>
            </div>
          </v-layout>
          <div style="display: flex;margin-right: 10px;">
            <v-layout class="ma-0" align-center fill-height>

              <v-tooltip bottom color="rgba(166, 166, 166, 0.5)" v-if="isNewData && $store.state.currFolderType == 1" >
                <template v-slot:activator="{ on, attrs }">
                  <v-badge color="#ff0000" dot offset-x="11" offset-y="6">
                    <span v-bind="attrs" v-on="on"  @click="refreshData" style="font-size:18px;color:#ffffff;cursor:pointer;" class="iconfontFamily">&#xe608;</span>
                  </v-badge>
                </template>
                <span style="color: white">文件数据已更新，点击立即同步</span>
              </v-tooltip>

                <v-tooltip bottom color="rgba(100, 100, 102, 1)"  >
                    <template v-slot:activator="{ on, attrs }">
                        <div v-show="(!isNewData)&& $store.state.currFolderType == 1"  v-on="on" v-bind="attrs" @click="refreshData" style="font-size:18px;color:#ffffff;cursor:pointer;" class="iconfontFamily">&#xe608;</div>
                    </template>
                    <span style="color: white">同步数据</span>
                </v-tooltip>


              <v-tooltip bottom color="rgba(100, 100, 102, 1)">
                <template v-slot:activator="{ on, attrs }">
                  <div @click="createFolderElement" style="font-size:20px;cursor:pointer;margin-left: 15px" class="iconfontFamily" v-bind="attrs" v-on="on">&#xe64f;</div>
                </template>
                <span style="color: white">新建文件夹</span>
              </v-tooltip>
              <div style="color: white;font-size: 20px;margin-left: 8px;cursor: pointer" class="iconfontFamily" @click="dataPanelOperation('close')">&#xeb47;</div>
            </v-layout>

          </div>

<!--          <v-spacer></v-spacer>-->
<!--          <v-tooltip bottom color="rgba(100, 100, 102, 1)">-->
<!--            <template v-slot:activator="{ on, attrs }">-->
<!--              <div style="width:20px;height:20px;margin-right:16px;cursor:pointer;" v-bind="attrs" v-on="on" @click="createFolder">-->
<!--                <p style="font-size:18px;" class="iconfontFamily">&#xe64f;</p>-->
<!--              </div>-->
<!--            </template>-->
<!--            <span style="color: white">新建文件夹</span>-->
<!--          </v-tooltip>-->
        </div>

        <!--无数据项-->
        <div v-show="$store.state.globeOperationMarkerList.length === 0" style="margin-top:54px;border-bottom-right-radius: 10px;border-bottom-left-radius:10px">
          <p style="margin-top:9px;line-height:21px;color:#808080;font-size:16px;text-align:center;">暂无数据</p>
          <p @click="openMarkerGuideVideo" style="width:120px;margin:21px auto 0 auto;line-height:21px;color:#63ACFF;font-size:16px;text-align:center;cursor:pointer;">
            <span style="margin-right:4px;font-size:16px;" class="iconfontFamily">&#xe778;</span>
            如何开始创作
          </p>

        </div>
        <!--标记点数据项-->
        <div v-show="$store.state.globeOperationMarkerList.length !== 0" class="myScrollArea"
             style="height:calc(100% - 54px);margin-top:54px;background: rgba(42, 42, 42, 1);overflow:auto;border-bottom-right-radius: 10px;border-bottom-left-radius:10px">
          <el-tree
                  :data="$store.state.globeOperationMarkerList"
                  style="background:rgba(42, 42, 42, 1);width: 100%"
                  node-key="id"
                  default-expand-all
                  :draggable="$store.state.currFolderRole === 1 ||$store.state.currFolderType === 0"
                  :expand-on-click-node="false"
                  :allow-drop="allowDrop"
                  highlight-current
                  @node-click="handleNodeClick"
                  ref="markerTree"
                  :current-node-key="currentNodeKey"
                  @node-drag-end="handleDragEnd"
          >

<!--            @node-drag-enter="handleDragEnter"-->
<!--            @node-drag-leave="handleDragLeave"-->
<!--            @node-drag-over="handleDragOver"-->
<!--            @node-drag-start="handleDragStart"-->

            <div class="custom-tree-node" slot-scope="{ node, data}" @mouseenter="nodeMouseover(node,data)" @mouseleave="nodeMouseout(node,data)" @dblclick="folderDblclick(node,data)">
              <div class="custom-tree-node" v-if="!data.isEditName">
                <div style="display: flex;align-items: center">
<!--                  <div v-if="data.avatar !==''">-->
<!--                    <v-avatar size="14">-->
<!--                      <v-img src="https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202108301117000116048_thumb.png"></v-img>-->
<!--                    </v-avatar>-->
<!--                  </div>-->
<!--                  <div v-else style="width: 16px;height: 16px;border-radius: 50%"></div>-->
                  <div style="font-size:14px;color: white;margin-left: 10px" class="iconfontFamily" :style="{'color':data.visible ? data.type === 'folder' ? '#69AFFF':'white':'#808080'}" v-html="itemTypeToIcon(data.type)" ></div>
                  <div class="tree-node-name" :style="{'color':data.visible ? '#ffffff':'#808080'}">{{ data.name }}</div>
                </div>
                <div style="display: flex;align-items: center" v-show="node.isCurrent || data.iconShow|| !data.visible">
                  <div  style="font-size:16px;color: white;cursor: pointer" @click="nodeExAndIm(node,data,$event)" class="iconfontFamily">{{data.visible? '&#xe671;':'&#xeb45;'}}</div>
                  <div v-show="node.isCurrent || data.iconShow || data.visible" style="font-size:16px;color: white;cursor: pointer;margin-left: 13px" @click="remove(node, data,$event)" class="iconfontFamily">&#xe720;</div>
                  <div v-show="!(node.isCurrent || data.iconShow || data.visible)" style="width: 29px"></div>
                </div>
              </div>
              <div style="width: 100%;display: flex;align-items: center" v-if="data.isEditName">
                <div style="font-size:14px;color: #69AFFF" class="iconfontFamily">&#xe64d;</div>
                <v-text-field
                        maxLength="100"
                        class="jumpTextField"
                        v-model="nodeName"
                        background-color="rgba(56, 56, 56, 1)"
                        style="font-size: 14px;color: white;height: 24px;margin-left: 5px"
                        solo
                        dark
                        autofocus
                        flat
                        dense
                        height="24"
                        @blur="blurNodeName(data)"
                ></v-text-field>
              </div>
            </div>
          </el-tree>
        </div>
      </div>
      <!--图层列表关闭-->
      <div v-if="!layerListShow" style="height:48px;width: 100%;border-radius:10px;background:rgba(42, 42, 42, 1);margin-top: 11px">
        <v-layout row class="ma-0" justify-space-between align-center fill-height>
          <div style="font-size: 16px;font-weight: bold;line-height: 22px;margin-left: 20px">图层列表</div>
          <div style="color: white;font-size: 20px;margin-right: 10px;cursor: pointer" class="iconfontFamily" @click="layerPanelOperation('open')">&#xe6a7;</div>
        </v-layout>
      </div>
      <!--图层列表打开-->
      <div v-else style="position:relative;margin-top: 11px;height: calc(100% - 258px);width: 100%;border-radius: 10px;background: rgba(42, 42, 42, 1)">
        <div style="position:fixed;width:310px;height:54px;padding:17px 0;background:#2a2a2a;display:flex;align-items:center;border-top-right-radius: 10px;border-top-left-radius:10px">
          <v-layout class="ma-0" fill-height justify-space-between align-center>
            <div style="display: flex">
              <div style="width:5px;height:20px;background:#20518A;border-radius:5px;"></div>
              <p style="margin-left:15px;font-size:16px;line-height:20px;">图层列表</p>
            </div>
          </v-layout>
          <div style="color: white;font-size: 20px;margin-right: 10px;cursor: pointer" class="iconfontFamily" @click="layerPanelOperation('close')">&#xeb47;</div>
        </div>
        <!--无数据项-->
        <div v-show="$store.state.globeOperationLayerList.length === 0" style="margin-top:54px;border-bottom-right-radius: 10px;border-bottom-left-radius:10px">
          <p style="margin-top:9px;line-height:21px;color:#808080;font-size:16px;text-align:center;">暂无数据</p>
        </div>
        <!--标记点数据项-->
        <div v-show="$store.state.globeOperationLayerList.length !== 0" class="myScrollArea"
             style="height:calc(100% - 54px);margin-top:54px;background: rgba(42, 42, 42, 1);overflow:auto;border-bottom-right-radius: 10px;border-bottom-left-radius:10px">
          <el-tree
                  :data="$store.state.globeOperationLayerList"
                  style="background:rgba(42, 42, 42, 1);width: 100%"
                  node-key="layerId"
                  default-expand-all
                  :expand-on-click-node="false"
                  highlight-current
                  ref="layerTree"
                  :current-node-key="currentLayerNodeKey"
          >
<!--              @node-click="layerTreeNodeClick""-->
            <div class="custom-tree-node" slot-scope="{ node, data}" @mouseenter="layerNodeMouseover(node,data)" @mouseleave="layerNodeMouseout(node,data)" @click="layerTreeNodeClick(data,node)">
              <div class="custom-tree-node">
                <div style="display: flex;align-items: center">
                  <div style="font-size:14px;color: white;" class="iconfontFamily">&#xe69e;</div>
                  <div class="tree-node-name" style="color:#ffffff">{{ data.name }}</div>
                </div>
                <div style="display: flex;align-items: center" v-show="node.isCurrent || data.iconShow">
                  <div v-show="node.isCurrent || data.iconShow" style="font-size:16px;color: white;cursor: pointer;margin-left: 13px" @click="removeLayerNode(node, data,$event)" class="iconfontFamily">&#xe720;</div>
                  <div v-show="!(node.isCurrent || data.iconShow)" style="width: 29px"></div>
                </div>
              </div>
            </div>
          </el-tree>
        </div>
      </div>


     <!-- 样例数据 :style="{'height':exampleShow ? '248px' : '50px'}"
      <div v-if="$store.state.exampleList.length !== 0" style="border-top:1px solid #545454;padding:15px 15px 11px 21px;">
        <div style="display:flex;align-items: center;">
          <p style="font-size:16px;">样例数据</p>
          <v-spacer></v-spacer>
          <p @click="$store.state.exampleShow = !$store.state.exampleShow" style="font-size:16px;cursor:pointer;">
            {{$store.state.exampleShow ? '隐藏' : '展开'}}
            <span style="margin-left:4px;" class="iconfontFamily">{{$store.state.exampleShow ? '&#xe65b;' : '&#xe722;'}}</span>
          </p>
        </div>
        <div v-show="$store.state.exampleShow" style="margin-top:11px;">
          <div style="overflow:hidden;">
            <div @click="openExample(item)" v-for="(item,index) in $store.state.exampleList.length > 4 ? $store.state.exampleList.slice(0,4) : $store.state.exampleList" :key="'example'+index"
                 style="margin:0 13px 10px 13px;float:left;cursor:pointer;">
              <v-img :src="item.picture" style="width:107px;height:71px;"></v-img>
            </div>
          </div>
          <div @click="exampleDialogShow=true" style="width:40px;height:22px;margin:0 auto;font-size:16px;color:#2A82E4;text-align:center;cursor:pointer;">
            更多
          </div>
        </div>

      </div>-->
    </div>



    <!--样例数据弹窗-->
    <marker-example v-if="exampleDialogShow" :dialogShow="exampleDialogShow" @closeDialog="exampleDialogShow = false" @addExampleToList="addExampleToList"></marker-example>


    <!--新建文件弹窗-->
    <create-globe-operation-folder v-if="createFolderShow" :dialogShow="createFolderShow" @closeDialog="createFolderShow = false" @createFolderOk="createFolderOk"></create-globe-operation-folder>


    <!--选择打开导入文件-->
     <choose-globe-operation-folder v-if="chooseFolderShow" :dialogShow="chooseFolderShow" @closeDialog="chooseFolderShow = false" @chooseFolderOk="chooseFolderOk" @chooseFolderUploadFileOk="chooseFolderUploadFileOk" @chooseFolderUploadFileError="chooseFolderUploadFileError"></choose-globe-operation-folder>


    <!--另存为文件弹窗-->
    <resave-globe-operation-folder v-if="resaveFolderShow" :dialogShow="resaveFolderShow" @closeDialog="resaveFolderShow = false" @resaveFolderOk="resaveFolderOk" @resaveFolderFailed="resaveFolderFailed"></resave-globe-operation-folder>


    <!--导出-->
    <export-globe-operation-folder v-if="exportFolderShow" :dialogShow="exportFolderShow" @closeDialog="exportFolderShow = false" @exportFolderOk="exportFolderOk"></export-globe-operation-folder>

    <!--团队文件成员-->
    <member-list-dialog v-if="memberListDialogShow" :dialogShow="memberListDialogShow" @closeDialog="memberListDialogShow = false" @dissolveTeamOk="dissolveTeamOk"  @reNameOk="reNameOk"></member-list-dialog>

    <!--邀请人员弹窗-->
    <invite-member-dialog v-if="inviteMemberDialogShow" :dialogShow="inviteMemberDialogShow" :inviteCode="this.inviteCode" @closeInviteDialog="closeInviteDialog" @inviteIntoTeamOk="inviteIntoTeamOk"></invite-member-dialog>

    <!--打开分享文件弹窗-->
    <open-share-file-dialog v-if="showOpenShareFileDialog" :show-open-share-file-dialog="showOpenShareFileDialog" :share-file-code="shareFileCode" @closeOpenShareFileDialog="closeOpenShareFileDialog" @goToMyFolder="goToMyFolder"></open-share-file-dialog>

  </div>

</template>

<script>
// import html2canvas from "html2canvas";
// import mapboxgl from "mapbox-gl";

import CreateGlobeOperationFolder from "@/views/globe/dialog/CreateGlobeOperationFolder";
import MarkerExample from "@/views/globe/dialog/MarkerExample";

import MixinMarker from "@/mixin/main_globe_operation_mixin/MainGlobeOperationMarker";
import MixinFolder from "@/mixin/main_globe_operation_mixin/MainGlobeOperationFolder";
import ChooseGlobeOperationFolder from "@/views/globe/dialog/ChooseGlobeOperationFolder";
import ResaveGlobeOperationFolder from "@/views/globe/dialog/ResaveGlobeOperationFolder";
import ExportGlobeOperationFolder from "@/views/globe/dialog/ExportGlobeOperationFolder";
import MemberListDialog from '@/views/globe/dialog/MemberListDialog'
import InviteMemberDialog from '@/views/globe/dialog/InviteMemberDialog'
import OpenShareFileDialog from "@/views/globe/dialog/file_manage/OpenShareFileDialog.vue";


export default {
  name: "MainGlobeOperation",
  mixins: [MixinMarker,MixinFolder],
// ,"smallGlobeMapInit"
  props:["mapboxInit"],
  components: {
    OpenShareFileDialog,
    ExportGlobeOperationFolder,
    ResaveGlobeOperationFolder, ChooseGlobeOperationFolder, MarkerExample, CreateGlobeOperationFolder,
    MemberListDialog,InviteMemberDialog
  },
  data(){
    return{

      // //搜索相关
      // search_keyword:"",
      // search_resultAreaShow:false,
      // search_resultAreaHistoryShow:false,
      // search_resultAreaAssociativeShow:false,
      // clickSearchItem:false,
      // search_history:[],
      // search_result:[],
      //
      // searching:false,

      // 分享个人文件链接相关
      showOpenShareFileDialog: false,
      shareFileCode: ''
    }


  },
  watch:{
    //搜索栏输入变化
    search_keyword(){
      if(this.search_keyword != null && this.search_keyword !== ""){
        if(!this.clickSearchItem){
          //不是点击结果导致的输入变化，需要搜索

          //判断输入是否符合经纬度格式
          if(this.search_keyword.indexOf(" ") !== -1){
            let keywordList = this.search_keyword.split(" ");

            if(keywordList[0] !== "" && keywordList[0] >= -180 && keywordList[0] <= 180 && keywordList[1] !== "" && keywordList[1] >= -90 && keywordList[1] <= 90){

              //输入的是经纬度
              this.search_result = [];
              this.search_result.push({
                name:"经纬度地点",
                location:{
                  lat: keywordList[1],
                  lng: keywordList[0]
                },
              })

              //进行地址关键字搜索
              this.$axios({
                method:"get",
                url:"/authorApi/POI/searchPoiList",
                params:{
                  keyWord:"",
                  lat:keywordList[1],
                  lon:keywordList[0]
                }
              }).then((resultData)=>{
                resultData = resultData.data;
                if(resultData.message === "ok"){
                  if(this.search_keyword != null && this.search_keyword !== ""){
                    //有经纬度的搜索结果
                    this.search_result = this.search_result.slice(0,1);
                    //插入poi的搜索结果
                    this.search_result = this.search_result.concat(resultData.result.pois.slice(0,9));

                    this.search_resultAreaShow = true;
                    this.search_resultAreaHistoryShow = false;
                    this.search_resultAreaAssociativeShow = true;
                  }
                  else{
                    this.search_resultAreaShow = true;
                    this.search_resultAreaHistoryShow = true;
                    this.search_resultAreaAssociativeShow = false;
                  }

                }
                else{
                  console.log(resultData.status + resultData.message);
                }
              }).catch((err)=>{
                console.log(err);
              });
            }
            else{

              //输入的是地址关键字
              this.$axios({
                method:"get",
                url:"/authorApi/POI/searchPoiList",
                params:{
                  keyWord:this.search_keyword,
                  lat:"",
                  lon:""
                }
              }).then((resultData)=>{
                resultData = resultData.data;
                if(resultData.message === "ok"){
                  if(this.search_keyword != null && this.search_keyword !== ""){
                    //联想搜索词
                    this.search_result = resultData.result;
                    this.search_resultAreaShow = true;
                    this.search_resultAreaHistoryShow = false;
                    this.search_resultAreaAssociativeShow = true;
                  }
                  else{
                    this.search_resultAreaShow = true;
                    this.search_resultAreaHistoryShow = true;
                    this.search_resultAreaAssociativeShow = false;
                  }

                }
                else{
                  console.log(resultData.status + resultData.message);
                }
              }).catch((err)=>{
                console.log(err);
              });


            }
          }

          else{
            //输入的是地址关键字
            this.$axios({
              method:"get",
              url:"/authorApi/POI/searchPoiList",
              params:{
                keyWord:this.search_keyword,
                lat:"",
                lon:""
              }
            }).then((resultData)=>{
              resultData = resultData.data;
              if(resultData.message === "ok"){
                if(this.search_keyword != null && this.search_keyword !== ""){
                  //联想搜索词
                  this.search_result = resultData.result;
                  this.search_resultAreaShow = true;
                  this.search_resultAreaHistoryShow = false;
                  this.search_resultAreaAssociativeShow = true;
                }
                else{
                  this.search_resultAreaShow = true;
                  this.search_resultAreaHistoryShow = true;
                  this.search_resultAreaAssociativeShow = false;
                }

              }
              else{
                console.log(resultData.status + resultData.message);
              }
            }).catch((err)=>{
              console.log(err);
            });

          }





        }
        else{
          this.clickSearchItem = false;
        }
      }
      else{
        this.getHistory();
      }

    },

    //监听是否展示搜索结果，判断是否显示地球蒙层
    search_resultAreaShow() {
      if(this.search_resultAreaShow){
        this.$parent.transparentMantle = true;
      }
      else{
        this.$parent.transparentMantle = false;
      }
    },

  },


  methods:{

    //关闭文件分享弹窗
    closeOpenShareFileDialog() {
      this.showOpenShareFileDialog = false
      this.shareFileCode = ''
      this.$router.push({
        path: '/globe'
      })
    },
    goToMyFolder() {
      this.$emit('goToMyFolder')
      this.closeOpenShareFileDialog()
    }
    // //搜索
    // //搜索框获得焦点
    // searchInputFocus(){
    //   this.search_resultAreaShow = true;
    //   if(this.search_keyword != null && this.search_keyword !== ""){
    //     this.search_resultAreaAssociativeShow = true;
    //     this.search_resultAreaHistoryShow = false;
    //   }
    //   else{
    //     this.getHistory();
    //   }
    //
    // },
    //
    // //搜索框失去焦点
    // searchInputBlur(){
    //   setTimeout(()=>{
    //     this.search_resultAreaShow = false;
    //   },200)
    // },
    //
    // //清空搜索框
    // clearSearchKeyword(){
    //   document.querySelector("#keywordInputArea_globeOperation").focus()
    //   this.search_keyword = '';
    // },
    //
    // //搜索框回车，选择第一项结果
    // searchInputEnter(){
    //   document.querySelector("#keywordInputArea_globeOperation").blur()
    //   this.clickSearchItem = true;
    //   // this.search_keyword = this.search_result[0].name;
    //   if(this.search_result[0].name === "经纬度地点"){
    //     this.search_keyword = this.search_result[0].location.lng + " " + this.search_result[0].location.lat;
    //     this.addHistory(this.search_result[0].name,this.search_result[0].location.lng,this.search_result[0].location.lat,2)
    //   }
    //   else{
    //     this.search_keyword = this.search_result[0].name;
    //     this.addHistory(this.search_result[0].name,this.search_result[0].location.lng,this.search_result[0].location.lat,1)
    //   }
    //
    //   this.flyToPosition(this.search_result[0].location.lng,this.search_result[0].location.lat);
    // },
    //
    //
    // //点击历史，选择点击的历史项作为结果
    // clickSearchHistory(item){
    //   this.clickSearchItem = true;
    //   // this.search_keyword = item.name;
    //
    //   if(item.type === 2){
    //     //经纬度地点
    //     this.search_keyword = item.lon + " " + item.lat;
    //     this.addHistory(item.keyWord,item.lon,item.lat,2)
    //   }
    //   else{
    //     this.search_keyword = item.keyWord;
    //     this.addHistory(item.keyWord,item.lon,item.lat,1)
    //   }
    //
    //   this.flyToPosition(item.lon,item.lat);
    //   this.search_resultAreaShow = false;
    //   this.search_resultAreaHistoryShow = false;
    // },
    //
    // //点击联想词，选择点击的联想词作为结果
    // clickSearchResult(item){
    //   this.clickSearchItem = true;
    //   if(item.name === "经纬度地点"){
    //     this.search_keyword = item.location.lng + " " + item.location.lat;
    //     this.addHistory(item.name,item.location.lng,item.location.lat,2)
    //   }
    //   else{
    //     this.search_keyword = item.name;
    //     this.addHistory(item.name,item.location.lng,item.location.lat,1)
    //   }
    //
    //   this.flyToPosition(item.location.lng,item.location.lat);
    //   this.search_resultAreaShow = false;
    //   this.search_resultAreaAssociativeShow = false;
    // },
    //
    // //地球飞到搜索结果位置
    // flyToPosition(positionLng,positionLat){
    //   this.$emit("flyToPosition",JSON.stringify({lng:positionLng,lat:positionLat}))
    // },
    //
    // //增加搜索历史
    // //type：1关键词搜索 2经纬度搜索
    // addHistory(positionName,lng,lat,type){
    //
    //   let param = new FormData();
    //   param.append('keyWord', positionName);
    //   param.append('lon', lng);
    //   param.append('lat', lat);
    //   param.append('type', type);
    //
    //   this.$axios({
    //     method:"post",
    //     url:"/authorApi/z-user-poi-search/add",
    //     data: param
    //   }).then((resultData)=>{
    //     resultData = resultData.data;
    //     if(resultData.status === 200){
    //       //添加历史成功
    //
    //     }
    //     else{
    //       console.log(resultData.status + resultData.message);
    //     }
    //   }).catch((err)=>{
    //     console.log(err);
    //   });
    //
    // },
    //
    // //获取并展示历史记录
    // getHistory(){
    //   this.$axios({
    //     method:"get",
    //     url:"/authorApi/z-user-poi-search/getByUser",
    //   }).then((resultData)=>{
    //     resultData = resultData.data;
    //     if(resultData.status === 200){
    //       this.search_history = resultData.data.slice(0,10);
    //       this.search_resultAreaShow = true;
    //       this.search_resultAreaHistoryShow = true;
    //       this.search_resultAreaAssociativeShow = false;
    //     }
    //     else{
    //       console.log(resultData.status + resultData.message);
    //     }
    //   }).catch((err)=>{
    //     console.log(err);
    //   });
    //
    // },
    //
    // //清空历史记录
    // clearSearchHistory(){
    //   this.$axios({
    //     method:"get",
    //     url:"/authorApi/z-user-poi-search/clearHistory",
    //   }).then((resultData)=>{
    //     resultData = resultData.data;
    //     if(resultData.status === 200){
    //       //历史记录清空
    //       this.search_history = [];
    //     }
    //     else{
    //       console.log(resultData.status + resultData.message);
    //     }
    //   }).catch((err)=>{
    //     console.log(err);
    //   });
    //
    // },

  },



  destroyed() {
    this.$emit("leftBarDestroy","globeOperation")
    window.removeEventListener('keydown', this.handleEvent)//ctrl+s监听销毁
    //清除监听
    clearInterval(this.newDataTemp)
    clearInterval(this.noReadTemp)
  },

  mounted(){
    if(!this.$store.state.initGlobeOperationMarker){
      let initTemp = setInterval(()=>{
        if(this.mapboxInit){
          clearInterval(initTemp)
          this.initFolderInfo()
          this.getMarkerExampleList();
          this.$store.state.initGlobeOperationMarker = true;
        }
      },200)
    }else{
      this.$emit("setLayerVisible")
      this.initFolderLayer()
    }
    //轮训查看数据是否有更新
    this.newDataTemp = setInterval(()=>{
      if(this.mapboxInit){
        if(this.$store.state.currFolderType === 1 ){
          //获取是否有新数据
          this.getFileIsUpdate()
        }
      }
    },2000)
    this.$emit("refreshMessage")
    //轮训查看消息队列
    this.noReadTemp = setInterval(()=>{
      if(this.mapboxInit){
        if(this.$store.state.currFolderType === 1){
          //获取是否有新的未读
          this.getNewNoRead()
        }
      }

    },2000)
    //全局监控ctrl+s
    window.addEventListener('keydown', this.handleEvent)
    //y设置邀请弹窗
    this.inviteCode  = window.localStorage.getItem('inviteCode')
    if(this.inviteCode){
      this.getInviteDialog()
    }
    // 显示分享文件弹窗
    this.shareFileCode = window.localStorage.getItem('shareFileCode')
    if (this.shareFileCode) {
      this.showOpenShareFileDialog = true
    }
  },



}
</script>

<style scoped>

.mainGlobeOperation{
  height:100%;
  padding:13px 15px 0 15px;
  /*overflow:auto;*/
}



.folderArea{
  width:100%;
  height:162px;
  border-radius: 10px;
  background-image:url('../../../assets/globe/globe_operation/folderBackground.png');
  background-size:cover;
  background-position: center;
  /*padding:16px 15px 16px 20px;*/
}
.folderArea-moreOperation{
  width:100%;
  background: #383838;
  box-shadow: 0px 0px 4px 0px #000000;
  border-radius:3px;
}
.folderArea-moreOperationItem{
  margin-bottom:18px;
  line-height:21px;
  font-size:14px;
  color:#ffffff;
}
.folderArea-moreOperationItem p{
  padding-left: 24px;
  cursor:pointer;
}


.editFolderNameTextField{
  padding-top:0;
  margin-top:-1px;
  font-size:18px;
}

</style>

<style>


/*#keywordInputArea_globeOperation{*/
/*  margin-right:28px;*/
/*}*/



/*编辑文件夹名称*/
.editFolderNameTextField .v-input__slot:before{
  border:none !important;
}
.editFolderNameTextField .v-input__slot:after{
  border:none !important;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  white-space: normal;
  height: 35px;
}

.el-tree {
  color:white !important;
}
.el-tree-node__content{
  height:35px !important;
}
.el-tree-node:focus > .el-tree-node__content {
  background-color: transparent !important;
}
.el-tree-node__content:hover {
  background-color: transparent !important;
  border-bottom: 1px solid rgba(0, 118, 209, 1)!important;
  border-top: 1px solid rgba(0, 118, 209, 1)!important;
}
.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  background-color: rgba(32, 81, 138, 1) !important;
}
.tree-node-name{
  font-size: 14px;
  margin-left: 5px;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.jumpTextField .v-input__slot{
  min-height: 24px !important;
  padding: 0 !important;
  margin: 0 !important;
}

</style>
